import React from 'react';
import ReactApexChart from 'react-apexcharts';

const ContactsGrowthChart = (props) => {
  const state = {
    series: [
      {
        name: 'Contact',
        type: 'bar',
        data: props?.data?.counts || [0, 0, 0, 0, 0, 0, 0],
      },
    ],

    options: {
      chart: {
        height: 320,
        type: 'bar',
        toolbar: {
          show: false,
          autoSelected: false,
          tools: {
            download: false,
          },
        },
      },

      plotOptions: {
        bar: {
          borderRadius: 5,
          dataLabels: {
            position: 'top', // Show data labels on top of bars
          },
          strokeWidth: 0, // Remove bar border stroke for clean look
          columnWidth: '40%',
        },
      },

      fill: {
        type: 'gradient',
        gradient: {
          type: 'vertical',
          colorStops: [
            {
              offset: 0,
              color: '#b94feb',
            },
            {
              offset: 100,
              color: '#f4543a',
            },
          ],
        },
      },

      dataLabels: {
        enabled: false,
        formatter: function (val) {
          return val;
        },
        offsetY: -20,
        style: {
          fontSize: '14px',
          colors: ['#333333'],
        },
      },

      grid: {
        show: true,
        borderColor: '#F2ECEC',
        strokeDashArray: 10,
        xaxis: {
          lines: {
            show: false,
          },
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },
      },

      xaxis: {
        categories: props?.data?.month || ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
        position: 'bottom',
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          style: {
            colors: '#666666',
            fontSize: '14px',
            fontWeight: '600',
          },
        },
        tooltip: {
          enabled: true,
        },
      },

      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: true, // Show Y-axis labels now
          formatter: function (val) {
            return val;
          },
          style: {
            colors: '#666666',
            fontSize: '12px',
          },
        },
      },
    },
  };

  return (
    <div className='react-chart'>
      <ReactApexChart options={state.options} series={state.series} type='bar' height={320} />
    </div>
  );
};

export default ContactsGrowthChart;
